module.exports = __webpack_public_path__ + "img/banner2_5.df91928e.png";